// @flow

// La ventana del free trial sigue abierta si hay fecha de fin configurada y aún
// no ha pasado. Misma regla que el backend (api-v4-users payment.js): new Date() < trial_end_date.
export const isTrialWindowOpen = (trial: ?{ endDate: ?string }): boolean => {
  const endDate = trial?.endDate;
  if (!endDate) return false;
  return new Date() < new Date(endDate);
};

// Decide si mostrar el badge promocional del free trial. Requiere duración (meses),
// que la ventana siga abierta y que el usuario no haya usado ya el trial.
export const shouldShowTrialPromo = (trial: ?{ months: ?number, endDate: ?string }, plusTrialUsed: ?boolean): boolean =>
  Boolean(trial?.months && isTrialWindowOpen(trial) && !plusTrialUsed);

// Extrae la info del free trial desde el array de metadata de un producto.
// Con professional=true prioriza la duración del segmento profesional (50103),
// con fallback a la duración general. Devuelve months=null si no hay duración válida (>0).
export const getTrialFromMetadata = (
  metadata: ?Array<{ meta: string, data: ?string }>,
  { professional = false }: { professional?: boolean } = {}
): { months: ?number, endDate: ?string } => {
  const find = (key: string): ?string => {
    const item = (metadata || []).find(meta => meta.meta === key);
    return item ? item.data : null;
  };

  const general = find('trial_duration');
  const segment = find('trial_duration_segment_50103');
  const raw = professional && segment ? segment : general;
  const months = raw != null && raw !== '' && !isNaN(Number(raw)) ? Number(raw) : null;

  return {
    months: months && months > 0 ? months : null,
    endDate: find('trial_end_date') || null
  };
};
